import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Password input with show/hide toggle (Gmail-style eye button)
export default function PasswordField({
  label,
  value,
  onChange,
  required = true,
  tid,
  className = "",
  autoComplete,
}) {
  const [show, setShow] = useState(false);
  return (
    <label className="block">
      {label && (
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8a8a8a] mb-2">{label}</div>
      )}
      <div className="relative">
        <input
          data-testid={tid}
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          autoComplete={autoComplete}
          className={`w-full px-3 py-2.5 pr-10 border border-[#0a0a0a] bg-white text-[#0a0a0a] font-sans focus:outline-none focus:border-[#ff006e] transition-colors ${className}`}
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "Hide password" : "Show password"}
          tabIndex={-1}
          className="absolute right-0 top-0 h-full w-10 flex items-center justify-center text-[#8a8a8a] hover:text-[#ff006e] transition-colors"
        >
          {show ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
    </label>
  );
}
